import type { FaireProductEntity } from "../../entity_types/product";

export const p_vug9zskfbp: FaireProductEntity = {
  token: "p_vug9zskfbp",
  type: "product",
  name: "Pink Ball Mug 17oz / 500ml stoneware ceramic — Party Collection",
  brandToken: "b_5ja2cf4hvd",
  brandName: "Egg Back Home USA",
  imageUrl:
    "https://cdn.faire.com/fastly/80f40c522d0824982a75465f85041f3401dcec4051003d89be067609db36f901.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3af2740431514da1559af50ab11adea8cb774638b51960c613a56b3f01977b3f.jpeg",
    "https://cdn.faire.com/fastly/4d221626e336d237766b74af5e7f733c4fa56a0d85d3f6bf31abf65629741684.jpeg",
    "https://cdn.faire.com/fastly/11af30de5bc1380d1cbca7122bca83be4b21470141b904038a0feb014aad604e.jpeg",
    "https://cdn.faire.com/fastly/a06ec21d907083eae904f5cb5f04e7bbe05ffab9b9e120bb8e658ac031b82421.jpeg",
  ],
  priceDollars: 17,
  description:
    "Introducing our delightful Party Ball Mug 17oz / 500ml. This captivating piece is a true embodiment of joy, boasting an enchanting design that effortlessly complements any occasion. The Party collection, renowned for its vibrant and lively aesthetic, finds its ultimate expression in this mug.\n\nDimensions:\n\nDiameter: 3.54 in\nHeight: 4.33 in\nCapacity: 17oz / 500ml\n\n\nAll our pieces are:\n\nDishwasher and microwave safe.\nFood safe.\nCadmium Free.\n\nMaterial: Stoneware with less than 3% absorption.\n\nOur Party Collection features a special type of glaze that may exhibit areas where speckles become diffused due to the glass's reactive nature during processing. We find these unique, unpredictable variations to be the most beautiful aspect of the glaze.\n\nCrafted with meticulous care, each Party Ball Mug 17oz / 500ml is a testament to our commitment to producing unique and exceptional tableware. Our artisanal process ensures that no two pieces are exactly alike, celebrating individuality. Please note that glaze colors may slightly vary due to production techniques. If you have any queries or seek more information, please don't hesitate to reach out to us.\n",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:59.855Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
